import * as del from './delete.js';
import * as deploy from './deploy.js';
import * as download from './download.js';

export const etl = [del, deploy, download];
